export enum DeliveryStatus {
  UNKNOWN = 'unknown',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  SENDING = 'sending',
}

export enum DeliveryErrorCode {
  NO_ERROR = 'NO_ERROR',
  GENERIC_PERM = 'GENERIC_PERM',
  SMS_INTL_PERM = 'SMS_INTL_PERM',
  OPTOUT_PERM = 'OPTOUT_PERM',
  SMS_LANDLINE_PERM = 'SMS_LANDLINE_PERM',
  GENERIC_TEMP = 'GENERIC_TEMP',
}

export enum GuestType {
  HOST = 'host',
  COHOST = 'cohost',
  PENDING_COHOST = 'pending_cohost',
  PLUS_ONE = 'plus_one',
  PENDING_PLUS_ONE = 'pending_plus_one',
  GUEST = 'guest',
  DRAFT = 'draft',
  GUEST_OF_HONOR = 'guest_of_honor',
}

export type InviteMethod = 'email' | 'sms';
export type RsvpResponse = 'yes' | 'no' | 'maybe' | 'undecided';

export type BaseGuest = {
  avatarUrl: string | null;
  checkedIn: boolean;
  comment: string | null;
  created: string;
  guestType: GuestType;
  longLink: string | null;
  name: string;
  numberOfAdults: number;
  numberOfKids: number;
  rsvpResponse: RsvpResponse;
  shortLink: string;
  updated: string;
  userId: string;
};

export type HostGuest = BaseGuest & {
  deliveryStatus: DeliveryStatus;
  email: string;
  inviteMethod: InviteMethod;
  invitedBy: string | null;
  phone: string | null;
  sentOn: string | null;
  timesViewed: number;
};

export type Guest = BaseGuest | HostGuest;

export function isHostGuest(guest: Guest | undefined): guest is HostGuest {
  if (!guest) return false;
  return 'email' in guest;
}
